import { SupplierAction, SupplierActionTypes } from '@completion/actions';
import {
  CheckSheetAssignment,
  CheckSheetAssignmentProjection,
  Punch,
  User,
  UserChecksheetAssignment,
  UserCheckSheetAssignmentProjection,
  Vendor,
} from '@completion/models';
import { ProcurementPackage } from '@completion/models';

export interface SupplierState {
  suppliers: User[];
  procurementPackages: ProcurementPackage[];
  selectedProcurementPackages: ProcurementPackage[];
  vendorUsersForSelectedScope: User[];
  selectedVendorUsersForScope: User[];
  selectedCheckSheetAssignments: CheckSheetAssignmentProjection[];
  availableCheckSheetAssignments: CheckSheetAssignmentProjection[];
  vendors: Vendor[];
  accessibleCheckSheetAssignmentIds: number[];
  currentUserScope?: CheckSheetAssignment[];
  scopeRelatedPunches: Punch[];
  usersWithOpenScope?: User[];
  selectedUserScope?: UserCheckSheetAssignmentProjection[];
  openScope?: CheckSheetAssignment[];
  scopeUsers?: User[];
  preparedTransmittals?: UserChecksheetAssignment[];
}

export const initialState: SupplierState = {
  suppliers: [],
  procurementPackages: [],
  selectedCheckSheetAssignments: [],
  availableCheckSheetAssignments: [],
  selectedProcurementPackages: [],
  vendorUsersForSelectedScope: [],
  selectedVendorUsersForScope: [],
  vendors: [],
  accessibleCheckSheetAssignmentIds: [],
  currentUserScope: [],
  scopeRelatedPunches: [],
  usersWithOpenScope: [],
  selectedUserScope: [],
  openScope: [],
  scopeUsers: [],
  preparedTransmittals: [],
};

export function supplierReducer(state: SupplierState = initialState, action: SupplierAction): SupplierState {
  switch (action.type) {
    case SupplierActionTypes.LoadSuppliersSuccess:
      return {
        ...state,
        suppliers: action.suppliers,
      };
    case SupplierActionTypes.LoadProcurementPackagesSuccess:
      return {
        ...state,
        procurementPackages: action.procurementPackages,
      };
    case SupplierActionTypes.AddProcurementPackageToSelection:
      return {
        ...state,
        selectedProcurementPackages: [...state.selectedProcurementPackages, action.procurementPackage],
      };
    case SupplierActionTypes.RemoveProcurementPackageFromSelection:
      return {
        ...state,
        selectedProcurementPackages: state.selectedProcurementPackages.filter(
          (procurementPackage) => procurementPackage.id !== action.procurementPackage.id,
        ),
      };
    case SupplierActionTypes.ClearSelectedProcurementPackages:
      return {
        ...state,
        selectedProcurementPackages: [],
      };

    case SupplierActionTypes.LoadPackageSowSuccess:
    case SupplierActionTypes.LoadLineTagSowSuccess:
      return {
        ...state,
        availableCheckSheetAssignments: action.supplierSow,
      };
    case SupplierActionTypes.SetSelectedSuppliers:
      return {
        ...state,
        vendorUsersForSelectedScope: action.selectedSuppliers,
      };

    case SupplierActionTypes.AddSelectedVendorUser:
      return {
        ...state,
        selectedVendorUsersForScope: [...state.selectedVendorUsersForScope, action.selectedVendorUser],
      };
    case SupplierActionTypes.RemoveSelectedVendorUser:
      return {
        ...state,
        selectedVendorUsersForScope: state.selectedVendorUsersForScope.filter((user) => user.id !== action.vendorUser.id),
      };

    case SupplierActionTypes.SetSelectedCheckSheetAssignments:
      return {
        ...state,
        selectedCheckSheetAssignments: action.selectedCheckSheetAssignments,
      };
    case SupplierActionTypes.ClearAvailableCheckSheetAssignments:
      return {
        ...state,
        availableCheckSheetAssignments: [],
      };
    case SupplierActionTypes.LoadVendorsSuccess:
      return {
        ...state,
        vendors: action.vendors,
      };
    case SupplierActionTypes.LoadVendorUsersForPackagesSuccess:
      return {
        ...state,
        vendorUsersForSelectedScope: action.users,
      };

    case SupplierActionTypes.GetAccessibleCheckSheetAssignmentIdsSuccess:
      return {
        ...state,
        accessibleCheckSheetAssignmentIds: action.checkSheetAssignmentIds,
      };
    case SupplierActionTypes.GetCurrentUserScopeSuccess:
      return {
        ...state,
        currentUserScope: action.currentUserScope,
      };
    case SupplierActionTypes.GetScopeRelatedPunchesSuccess:
      return {
        ...state,
        scopeRelatedPunches: action.scopeRelatedPunches,
      };

    case SupplierActionTypes.ResetSupplierState:
      return {
        ...initialState,
      };

    case SupplierActionTypes.GetUsersWithOpenAssignmentsSuccess:
      return {
        ...state,
        usersWithOpenScope: action.usersWithOpenAssignments,
      };
    case SupplierActionTypes.GetAssignmentsForUserSuccess:
      return {
        ...state,
        selectedUserScope: action.userAssignments,
      };
    case SupplierActionTypes.SetPreparedTransmittals:
      return {
        ...state,
        preparedTransmittals: action.preparedTransmittals,
      };
    default:
      return state;
  }
}
